var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext } from 'react';
import { translate } from '@utils/i18n';
import { Controller, useFormContext } from 'react-hook-form';
import { EditGenericEventModalContext } from '../../context/EditGenericEventModalContext';
function AdvancedSection() {
    const namespace = 'features.modals.edit_generic_event_modal.advanced_section';
    const { control, watch, getValues, trigger } = useFormContext();
    const { handleModalSave } = useContext(EditGenericEventModalContext);
    const formValues = watch();
    const displayEndDate = formValues.recurrence.endDate || formValues.recurrence.occurrencesEndDate;
    const handleChange = (field, value) => __awaiter(this, void 0, void 0, function* () {
        field.onChange(value);
        const isValid = yield trigger();
        if (isValid) {
            handleModalSave({ genericEvent: getValues() });
        }
    });
    return (React.createElement("div", { className: "advancedSection" },
        React.createElement(Controller, { name: "conflictable", control: control, render: ({ field }) => (React.createElement("div", { className: "qmb-checkbox" },
                React.createElement("input", { id: field.name, type: "checkbox", checked: field.value, onChange: (value) => handleChange(field, value) }),
                React.createElement("label", { htmlFor: field.name, className: "qmb-label" }, translate('show_as_busy', { namespace })))) }),
        formValues.isRecurring && (React.createElement("div", { className: "info-row" },
            React.createElement("i", { className: "fa-light fa-circle-info mr-1" }),
            translate('is_recurring_event', {
                namespace,
                frequency: formValues.recurrence.displayFrequency,
                end_date: displayEndDate === null || displayEndDate === void 0 ? void 0 : displayEndDate.format('M/D/YYYY')
            })))));
}
export default AdvancedSection;
